import React, { useState } from 'react'
 
 
import DiscountApprovalList from './DiscountApprovalList';
import DiscountApprovalForm from './DiscountApprovalForm';

const DiscountApproval= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <DiscountApprovalForm addForm={setFromIsShown} update={upData} />
        ) : (
          <DiscountApprovalList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default DiscountApproval